import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';

const StudentDetails = () => {
  const [formData, setFormData] = useState({
    name: '',
    usn: '',
    email: '',
    password: '',
    phone: '',
    cgpa: '',
    branch: '',
    graduationYear: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await api.post('/auth/register/student', {
        ...formData,
        usn: formData.usn.toUpperCase() // ✅ Convert to uppercase
      });

      console.log('Registration response:', response.data); // Debug log
      
      // ✅ CRITICAL FIX: Save correct IDs to localStorage
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      localStorage.setItem('usn', response.data.user.usn);  // ✅ Save USN from user object
      localStorage.setItem('userId', response.data.studentId);  // ✅ Save studentId (NOT user.id!)
      localStorage.setItem('userRole', 'student');

      console.log('Saved to localStorage:', {
        token: localStorage.getItem('token'),
        usn: localStorage.getItem('usn'),
        userId: localStorage.getItem('userId')
      }); // Debug log

      alert('✅ Registration successful!');
      navigate('/tables');
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed');
      console.error('Registration error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.formBox}>
        <h2 style={styles.heading}>Student Registration</h2>
        {error && <div style={styles.error}>{error}</div>}
        <form onSubmit={handleRegister} style={styles.form}>
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value={formData.name}
            onChange={handleChange}
            required
            style={styles.input}
          />
          <input
            type="text"
            name="usn"
            placeholder="USN (e.g., 4SF22CS061)"
            value={formData.usn}
            onChange={handleChange}
            required
            style={styles.input}
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
            style={styles.input}
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
            style={styles.input}
            minLength="6"
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone"
            value={formData.phone}
            onChange={handleChange}
            required
            style={styles.input}
          />
          <input
            type="number"
            step="0.01"
            name="cgpa"
            placeholder="CGPA (e.g., 9.54)"
            value={formData.cgpa}
            onChange={handleChange}
            required
            style={styles.input}
            min="0"
            max="10"
          />
          <input
            type="text"
            name="branch"
            placeholder="Branch (e.g., Computer Science)"
            value={formData.branch}
            onChange={handleChange}
            required
            style={styles.input}
          />
          <input
            type="number"
            name="graduationYear"
            placeholder="Graduation Year (e.g., 2026)"
            value={formData.graduationYear}
            onChange={handleChange}
            required
            style={styles.input}
            min="2020"
            max="2030"
          />
          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? 'Registering...' : 'Register'}
          </button>
        </form>
        <Link to="/login" style={styles.link}>Already have an account? Login</Link>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    padding: '1rem',
  },
  formBox: {
    background: 'white',
    padding: '2rem',
    borderRadius: '10px',
    boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
    width: '100%',
    maxWidth: '500px',
  },
  heading: {
    textAlign: 'center',
    color: '#333',
    marginBottom: '1.5rem',
  },
  error: {
    padding: '0.75rem',
    background: '#fee',
    color: '#c33',
    borderRadius: '5px',
    marginBottom: '1rem',
    textAlign: 'center',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  input: {
    padding: '0.75rem',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '1rem',
  },
  button: {
    padding: '0.75rem',
    background: '#667eea',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    fontSize: '1rem',
    cursor: 'pointer',
  },
  link: {
    display: 'block',
    textAlign: 'center',
    marginTop: '1rem',
    color: '#667eea',
    textDecoration: 'none',
    fontSize: '0.9rem',
  },
};

export default StudentDetails;
